import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.css']
})
export class PasswordUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
